// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from 'firebase'

// Add the Firebase products that you want to use
import "firebase/analytics"

var firebaseConfig = {
  apiKey: "AIzaSyChM26yzya0FDiGgCc0v07XqLw8CwTCvzQ",
  authDomain: "portfolio-762f6.firebaseapp.com",
  databaseURL: "https://portfolio-762f6.firebaseio.com",
  projectId: "portfolio-762f6",
  storageBucket: "portfolio-762f6.appspot.com",
  messagingSenderId: "751496033624",
  appId: "1:751496033624:web:7fdc25de06aa1b59f9212d",
  measurementId: "G-8R5977DX2W"
};

export default {
  init() {
    firebase.initializeApp(firebaseConfig)
    firebase.analytics()
  },
}